import { Box, Button, CircularProgress, Grid } from "@mui/material";
import { MessageDeliveryType } from "../../../../App/Enums/Message";
import { getMessageDisplayType } from "../../../../MessageComponents/FunctionMethods/MessageFunctions";
import MessageDialogCandidateEmail from "../../../../MessageComponents/MessageDialog/MessageDialogCandidateEmail";
import CandidateMessageContainer from "../../../Components/CandidateMessageContainer";
import ContactList from "../../../Components/ContactList";
import ContactListFilters from "../../../Components/ContactListFilters";
import { FilterContextProvider } from "../../../State/FilterContext";
import { GroupsContextProvider } from "../../../State/GroupsContext";
import { MessagesContextProvider, useMessagesContext } from "../../../State/MessagesContext";
import EmailListing from "../EmailListing";
import ViewEmailModal from "../ViewEmailModal";

export default function EmailMessageListingTab() {
  return (
    <GroupsContextProvider>
      <FilterContextProvider>
        <MessagesContextProvider>
          <Grid container columnSpacing={{ xs: 4, xl: 6 }} rowSpacing={3}>
            <Grid item xs={12}>
              <ContactListFilters />
            </Grid>
            <Grid item xs={12} sm={12} md={4} xl={3}>
              <ContactList type={MessageDeliveryType.Email} />
            </Grid>
            <Grid item xs={12} sm={12} md={8} xl={9}>
              <MessagesContainerWithContext />
            </Grid>
          </Grid>
          <ViewEmailModal showReplyButton={true} />
          <MessageDialogEmailWithContext />
        </MessagesContextProvider>
      </FilterContextProvider>
    </GroupsContextProvider>
  );
}

const MessagesContainerWithContext = () => {
  const { messageDataFetched, messages, handleEmailClick, setSelectedMessageId } = useMessagesContext();
  const handleSendEmailClick = () => {
    setSelectedMessageId("");
    handleEmailClick();
  };
  return (
    <CandidateMessageContainer
      headerComponents={
        <Button
          color="secondary"
          variant="contained"
          size="small"
          sx={{ maxHeight: "50px", marginTop: 1, marginRight: 2, pl: 5, pr: 5 }}
          data-test="message-center-send-email-button"
          onClick={handleSendEmailClick}
        >
          Send Email
        </Button>
      }
    >
      {!messageDataFetched && !messages ? (
        <Box
          sx={{
            minHeight: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <EmailListing />
      )}
    </CandidateMessageContainer>
  );
};

const MessageDialogEmailWithContext = () => {
  const { selectedCandidate, selectedMessageId, messageDetail } = useMessagesContext();
  return (
    <MessageDialogCandidateEmail
      key={`${selectedCandidate?.id}-${selectedMessageId || "new"}`}
      replyEmail={
        messageDetail &&
        messageDetail.id.toLowerCase() === selectedMessageId.toLowerCase() &&
        getMessageDisplayType(messageDetail.messageType) === "reply"
          ? messageDetail
          : undefined
      }
      candidate={selectedCandidate ?? undefined}
      disableScheduling={true}
    />
  );
};
